import { ROUTES } from '@ab-core/functions';
import { Link, LINK_VARIANT } from '@ab-core/link';
import { getTestIdProp } from '@ab-core/testing';
import type { TextProps } from '@ab-core/text';
import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import type { ScalableStyle } from '../../scalableStyles';
import { StyledNameContainer, TextContainer } from './styled';

export type NameContainerPropsStyleType = ScalableStyle<{
    isVisible: boolean;
    isClickable?: boolean;
}>;

export type NameContainerProps = {
    text?: string;
    link?: string;
    sku?: string;
    position?: number;
    mainId?: string;
};

const textStyle: TextProps = {
    color: 'inherit',
    type: FontTypes.Title
};

export const NameContainer: FC<NameContainerProps & NameContainerPropsStyleType> = (props) => {
    const { text, sku, position, scalableStyle, link = `${ROUTES.PRODUCTPAGE}/${sku}`, mainId } = props;

    if (!scalableStyle?.isVisible) {
        return <></>;
    }

    if (scalableStyle?.isClickable !== undefined && !scalableStyle?.isClickable) {
        return (
            <StyledNameContainer>
                <Text {...textStyle} {...getTestIdProp('product-card-name')}>
                    <TextContainer>{text}</TextContainer>
                </Text>
            </StyledNameContainer>
        );
    }

    return (
        <StyledNameContainer>
            <Link
                to={link}
                state={{ previousUrl: window.location.search, position, mainId }}
                variant={LINK_VARIANT.LINK_ONLY}
                title={text}
            >
                <Text {...textStyle} {...getTestIdProp('product-card-name')}>
                    <TextContainer>{text}</TextContainer>
                </Text>
            </Link>
        </StyledNameContainer>
    );
};
